import React, { useEffect, useState } from "react";
import type { MenuProps } from "antd";
import { Layout, Menu, theme } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { HeaderComponent } from "./common/Header";
import { PreAuthz, preAuthzElementFn, preAuthzFn } from "./security/Authz";
import { title } from "process";
import SubMenu from "antd/es/menu/SubMenu";
import { useSelector } from "react-redux";
import {
  Books,
  ChartArcs,
  ChartArrows,
  ChartDots,
  Dashboard,
} from "../ImportData";
import { WhatsApp } from "./whatsapp/WhatsApp";
import { WhatsAppModule } from "./whatsapp/WhatsAppIntegration";
import { SideMenu } from "./common/SideMenu";

const { Content, Sider } = Layout;


const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    console.log("initialize home component");
  }, []);

console.log("render home component");
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          width={250}
          style={{ height: "100vh" }}
          theme="light"
          className="leftPanelMenu"
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="slidePanelLogoBox">
            <img
              src="https://cdn.efficienttourism.com/wp-content/uploads/2022/09/logo-300.png"
              style={{ width: "calc(100% - 40px)" }}
            />
          </div>
          <div className="slidePanelLogoCollapsed">
            <span></span>
          </div>
          <SideMenu />
        </Sider>
        <Layout style={{ height: "100vh", overflowY: "auto" }}>
          <HeaderComponent setCollapsed={setCollapsed} collapsed={collapsed} />
          <Content
            style={{
              background: "#f8f8f8",
              borderRadius: 0,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export { Home };
